// @push.rocks ecosystem
import * as isounique from '@push.rocks/isounique';

export { isounique };
